module.exports = __webpack_public_path__ + "hinted-OpenSans-Bold.3e5c6fe23fdae7cb74e5.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-OpenSans-Bold.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-OpenSans-Bold.woff
// module chunks = 1